import React, { Fragment,useState } from "react";
import { Col, Row, Button, Form, FormGroup, Label, Input } from "reactstrap";
// Layout
import { authProvider } from "../../config/authProvider";
import { useHistory  } from 'react-router-dom';
import {toast} from "react-toastify";

const Login = ({ match }) => {

    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const history = useHistory(); 

    const handleLogin = async () => {
        try {
          await authProvider.login({ username, password });
          history.push("/");
        } catch (err) {
            toast.error("Invalid credentials");
        }
    };

return(
  <Fragment>
    <div className="h-100 bg-royal bg-animation">
      <div className="d-flex h-100 justify-content-center align-items-center">
        <Col md="8" className="mx-auto app-login-box">
          <div className="app-logo-inverse mx-auto mb-3" />
          <div className="modal-dialog w-100 mx-auto">
            <div className="modal-content">
              <div className="modal-body">
                <div className="h5 modal-title text-center">
                  <h4 className="mt-2">
                    <div>Welcome</div>
                    <span>Please sign in to your account below.</span>
                  </h4>
                </div>
                <Form>
                  <Row form>
                    <Col md={12}>
                      <FormGroup>
                        <Input type="email" name="email" id="exampleEmail" value={username} onChange={(e) => setUsername(e.target.value)} placeholder="Username here..."/>
                      </FormGroup>
                    </Col>
                    <Col md={12}>
                      <FormGroup>
                        <Input type="password" name="password" id="examplePassword" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password here..."/>
                      </FormGroup>
                    </Col>
                  </Row>
                </Form>
              </div>
              <div className="modal-footer clearfix">
                <div className="float-end">
                  <Button color="primary" size="lg" onClick={handleLogin}>
                    Login to Dashboard
                  </Button>
                </div>
              </div>
            </div>
          </div>
          
        </Col>
      </div>
    </div>
  </Fragment>
);
};

export default Login;
